module.exports = __webpack_public_path__ + "img/metaplace_portal.25e672b9.jpg";